export const STROKE_WIDTH = 2;
export const BASE_FONT_SIZE = 12;
